export enum ErrorCode {
  // Auth
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  UNAUTHORIZED = "UNAUTHORIZED",
  PASSWORD_NOT_SET = "PASSWORD_NOT_SET",
  VERIFICATION_REQUIRED = "VERIFICATION_REQUIRED",
  EMAIL_NOT_VERIFIED = "EMAIL_NOT_VERIFIED",
  PHONE_NOT_VERIFIED = "PHONE_NOT_VERIFIED",
  EMAIL_AND_PHONE_NOT_VERIFIED = "EMAIL_AND_PHONE_NOT_VERIFIED",
  INVALID_TOKEN = "INVALID_TOKEN",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  USER_INACTIVE = "USER_INACTIVE",

  // Password validation
  PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT",
  PASSWORD_MISSING_UPPERCASE = "PASSWORD_MISSING_UPPERCASE",
  PASSWORD_MISSING_LOWERCASE = "PASSWORD_MISSING_LOWERCASE",
  PASSWORD_MISSING_NUMBER = "PASSWORD_MISSING_NUMBER",
  PASSWORD_MISSING_SPECIAL = "PASSWORD_MISSING_SPECIAL",
  PASSWORDS_DO_NOT_MATCH = "PASSWORDS_DO_NOT_MATCH",

  // User management
  USER_NOT_FOUND = "USER_NOT_FOUND",
  EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
  USERNAME_ALREADY_EXISTS = "USERNAME_ALREADY_EXISTS",

  // Transfer methods
  TRANSFER_METHOD_NAME_EXISTS = "TRANSFER_METHOD_NAME_EXISTS",

  // Provider assignments
  PROVIDER_NOT_FOUND = "PROVIDER_NOT_FOUND",
  INVALID_PROVIDER_ROLE = "INVALID_PROVIDER_ROLE",
  ASSIGNMENT_ALREADY_EXISTS = "ASSIGNMENT_ALREADY_EXISTS",
  TRANSFER_METHOD_NOT_FOUND = "TRANSFER_METHOD_NOT_FOUND",
  ASSIGNMENT_NOT_FOUND = "ASSIGNMENT_NOT_FOUND",
  DEPOSIT_NOT_ALLOWED = "DEPOSIT_NOT_ALLOWED",
  WITHDRAWAL_NOT_ALLOWED = "WITHDRAWAL_NOT_ALLOWED",

  // Operations
  DEPOSIT_NOT_FOUND = "DEPOSIT_NOT_FOUND",
  WITHDRAWAL_NOT_FOUND = "WITHDRAWAL_NOT_FOUND",
  PROVIDER_NOT_CONFIGURED_FOR_OPERATION = "PROVIDER_NOT_CONFIGURED_FOR_OPERATION",
  OPERATION_ALREADY_TAKEN = "OPERATION_ALREADY_TAKEN",
  OPERATION_NOT_ASSIGNED_TO_YOU = "OPERATION_NOT_ASSIGNED_TO_YOU",
  OPERATION_NOT_ASSIGNED = "OPERATION_NOT_ASSIGNED",
  OPERATION_CANNOT_BE_RELEASED = "OPERATION_CANNOT_BE_RELEASED",
  OPERATION_CANNOT_BE_CANCELLED = "OPERATION_CANNOT_BE_CANCELLED",
  OPERATION_NOT_IN_PROCESSING = "OPERATION_NOT_IN_PROCESSING",
  DEPOSIT_ALREADY_PROCESSED = "DEPOSIT_ALREADY_PROCESSED",
  WITHDRAWAL_ALREADY_PROCESSED = "WITHDRAWAL_ALREADY_PROCESSED",
  CONCURRENCY_CONFLICT = "CONCURRENCY_CONFLICT",
  REQUIRED_FIELD_MISSING = "REQUIRED_FIELD_MISSING",
  ACCESS_DENIED = "ACCESS_DENIED",

  // Generic
  INTERNAL_ERROR = "INTERNAL_ERROR",
  CONNECTION_ERROR = "CONNECTION_ERROR",
}

export const errorMessages: Record<string, string> = {
  [ErrorCode.INVALID_CREDENTIALS]: "errors.invalid-credentials",
  [ErrorCode.UNAUTHORIZED]: "session-expired",
  [ErrorCode.PASSWORD_NOT_SET]: "errors.password-not-set",
  [ErrorCode.VERIFICATION_REQUIRED]: "errors.verification-required",
  [ErrorCode.EMAIL_NOT_VERIFIED]: "errors.email-not-verified",
  [ErrorCode.PHONE_NOT_VERIFIED]: "errors.phone-not-verified",
  [ErrorCode.EMAIL_AND_PHONE_NOT_VERIFIED]: "errors.email-and-phone-not-verified",
  [ErrorCode.INVALID_TOKEN]: "errors.token-invalid",
  [ErrorCode.TOKEN_EXPIRED]: "errors.token-expired",
  [ErrorCode.USER_INACTIVE]: "errors.user-inactive",
  [ErrorCode.PASSWORD_TOO_SHORT]: "errors.password-too-short",
  [ErrorCode.PASSWORD_MISSING_UPPERCASE]: "errors.password-missing-uppercase",
  [ErrorCode.PASSWORD_MISSING_LOWERCASE]: "errors.password-missing-lowercase",
  [ErrorCode.PASSWORD_MISSING_NUMBER]: "errors.password-missing-number",
  [ErrorCode.PASSWORD_MISSING_SPECIAL]: "errors.password-missing-special",
  [ErrorCode.PASSWORDS_DO_NOT_MATCH]: "errors.passwords-do-not-match",
  [ErrorCode.USER_NOT_FOUND]: "errors.user-not-found",
  [ErrorCode.EMAIL_ALREADY_EXISTS]: "errors.email-already-exists",
  [ErrorCode.USERNAME_ALREADY_EXISTS]: "errors.username-already-exists",
  [ErrorCode.TRANSFER_METHOD_NAME_EXISTS]: "errors.transfer-method-name-exists",
  [ErrorCode.PROVIDER_NOT_FOUND]: "errors.provider-not-found",
  [ErrorCode.INVALID_PROVIDER_ROLE]: "errors.invalid-provider-role",
  [ErrorCode.ASSIGNMENT_ALREADY_EXISTS]: "errors.assignment-already-exists",
  [ErrorCode.TRANSFER_METHOD_NOT_FOUND]: "errors.transfer-method-not-found",
  [ErrorCode.ASSIGNMENT_NOT_FOUND]: "errors.assignment-not-found",
  [ErrorCode.DEPOSIT_NOT_ALLOWED]: "errors.deposit-not-allowed",
  [ErrorCode.WITHDRAWAL_NOT_ALLOWED]: "errors.withdrawal-not-allowed",
  [ErrorCode.DEPOSIT_NOT_FOUND]: "errors.deposit-not-found",
  [ErrorCode.WITHDRAWAL_NOT_FOUND]: "errors.withdrawal-not-found",
  [ErrorCode.PROVIDER_NOT_CONFIGURED_FOR_OPERATION]: "errors.provider-not-configured",
  [ErrorCode.OPERATION_ALREADY_TAKEN]: "errors.operation-already-taken",
  [ErrorCode.OPERATION_NOT_ASSIGNED_TO_YOU]: "errors.operation-not-assigned-to-you",
  [ErrorCode.OPERATION_NOT_ASSIGNED]: "errors.operation-not-assigned",
  [ErrorCode.OPERATION_CANNOT_BE_RELEASED]: "errors.operation-cannot-be-released",
  [ErrorCode.OPERATION_CANNOT_BE_CANCELLED]: "errors.operation-cannot-be-cancelled",
  [ErrorCode.OPERATION_NOT_IN_PROCESSING]: "errors.operation-not-in-processing",
  [ErrorCode.DEPOSIT_ALREADY_PROCESSED]: "errors.deposit-already-processed",
  [ErrorCode.WITHDRAWAL_ALREADY_PROCESSED]: "errors.withdrawal-already-processed",
  [ErrorCode.CONCURRENCY_CONFLICT]: "errors.concurrency-conflict",
  [ErrorCode.REQUIRED_FIELD_MISSING]: "errors.required-field-missing",
  [ErrorCode.ACCESS_DENIED]: "errors.access-denied",
  [ErrorCode.INTERNAL_ERROR]: "errors.internal-error",
  [ErrorCode.CONNECTION_ERROR]: "errors.connection-error",
};

export function getErrorMessageKey(errorCode: string): string {
  return errorMessages[errorCode] || "errors.unexpected";
}
